module.exports = __webpack_public_path__ + "static/media/Syeda_S_Ara_DDS.0238c881.png";